import {
  GET_ACTIVE_WHEEL_FAIL,
  GET_ACTIVE_WHEEL_RESET,
  GET_ACTIVE_WHEEL_START,
  GET_ACTIVE_WHEEL_SUCCESS,
} from './constants';
import {GetActiveWheelActions, GetActiveWheelState} from './types';

const initialState: GetActiveWheelState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: GetActiveWheelActions,
): GetActiveWheelState => {
  switch (action.type) {
    case GET_ACTIVE_WHEEL_START:
      return {
        ...initialState,
        loading: true,
      };
    case GET_ACTIVE_WHEEL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_ACTIVE_WHEEL_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_ACTIVE_WHEEL_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
